import React from 'react';

import { VStack, Divider } from '@vivaahealth/design-system';

import * as api from '../../../../api';

import Contact from './Contact';

import { maybeFormatNumberToNational } from '../../../../utils/phoneNumber';

interface EmergencyContactProps {
  field: api.PrevisitFormField.PrevisitFormFieldWithConfig;
}

const EmergencyContacts = ({ field }: EmergencyContactProps) => {
  const emergencyContacts: api.Previsit.PatientEmergencyContact[] = JSON.parse(
    field.value,
  ).filter(
    (contact: api.Previsit.PatientEmergencyContact) =>
      contact.status !== api.Previsit.ModificationStatus.Removed,
  );

  const lastContactIndex = emergencyContacts.length - 1;

  return (
    <VStack gap={16}>
      {emergencyContacts.map((emergencyContact, idx) => {
        const relationship =
          api.Previsit.relationshipMap[
            emergencyContact.emergencyContactRelationshipToPatient
          ];
        const contactPhone =
          maybeFormatNumberToNational(
            emergencyContact.cellPhoneNumber ||
              emergencyContact.homePhoneNumber ||
              '',
          ) || '';
        return (
          <React.Fragment key={idx}>
            <Contact
              firstName={emergencyContact.firstName}
              lastName={emergencyContact.lastName}
              relationship={relationship}
              contactPhoneNumber={contactPhone}
            />
            {lastContactIndex !== idx && <Divider />}
          </React.Fragment>
        );
      })}
    </VStack>
  );
};

export default EmergencyContacts;
